import { observer } from 'mobx-react';
import * as React from 'react';
import { DisplayDate } from 'owa-datetime';
import { getTimeUntilString } from '../selectors/userConfigSelectors';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observableNow } from 'owa-observable-datetime';

const styles = require('./AgendaEventTimeUntilView.scss');

export interface TimeUntilViewProps {
    startDate: DisplayDate;
    endDate: DisplayDate;
    containerClassName: string;
}

@observer
export class TimeUntilView extends React.Component<TimeUntilViewProps, {}> {
    render() {
        const { startDate, endDate, containerClassName } = this.props;
        return (
            <div className={containerClassName}>
                <div className={styles.innerContainer}>
                    <Icon iconName={ControlIcons.Clock} className={styles.clockIcon} />
                    <span>{getTimeUntilString(startDate, endDate, observableNow())}</span>
                </div>
            </div>
        );
    }
}
